import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../context/User/userProvider";
import { AppContext } from "../context/App/appProvider";

/**
 * This hook allows us to fetch the onboarding details much easier. Since we call this
 * on so many pages, I figured it would be great to have all the logic in one spot.
 */

export default function useOnboardingDetails() {
  const {
    onboardingDetails,
    getOnboardingDetails,
    onboardingDetailsFetched,
    fetchingOnboardingDetails,
    updateIntegrationDetails,
    isHRISConnected,
    getFinchClientId,
    createHRIntegration,
    getCompanyDetails,
    updateOnboardingDetails,
  } = useContext(UserContext);
  const { setShowFullScreenLoader } = useContext(AppContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setShowFullScreenLoader(true);
  }, []);

  useEffect(() => {
    if (onboardingDetails?.companyDetails?.hrisAccessToken) {
      updateIntegrationDetails(true);
    }
  }, [onboardingDetails?.companyDetails?.hrisAccessToken]);

  const init = useCallback(() => {
    if (!fetchingOnboardingDetails && onboardingDetailsFetched) {
      setLoading(false);
      setShowFullScreenLoader(false);
      return;
    }
    if (!fetchingOnboardingDetails) {
      getOnboardingDetails();
    }
  }, [fetchingOnboardingDetails, onboardingDetailsFetched]);

  useEffect(init, [init]);

  return {
    getOnboardingDetails,
    loading,
    onboardingDetails,
    updateIntegrationDetails,
    isHRISConnected,
    getFinchClientId,
    createHRIntegration,
    getCompanyDetails,
    updateOnboardingDetails,
  };
}
